__webpack_require__.j = "news";